var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-dialog',{ref:"dialog",attrs:{"title":_vm.$t('message.confirm'),"message":'未読状態にしますか?',"cancel-text":_vm.$t('message.modal_cancel_btn'),"submit-text":'実行',"max-width":"350"},on:{"submit":function($event){return _vm.submit()}}})}
var staticRenderFns = []

export { render, staticRenderFns }